import { constantRoutes, asyncRoutes } from '@/router';
const MenuModule = {
    namespaced: true,
    state: {
        routes: [...constantRoutes, ...asyncRoutes[0].children]
    },
    getters: {
        menus: (state) => state.routes
    },
    mutations: {
    // setRoutes(state, routes: Array<RouteConfig>) {
    //   state.routes = constantRoutes.concat(routes)
    // }
    },
    actions: {
    // async generateRoutes({ commit }): Promise<Array<RouteConfig>> {
    //   const accessedRoutes = asyncRoutes
    //   commit('setRoutes', accessedRoutes[0].children)
    //   return accessedRoutes
    // }
    }
};
export default MenuModule;
